import { StateCreator } from 'zustand';
import { OptionsSlice } from './options.types';

export const createOptionsSlice: StateCreator<
  OptionsSlice,
  [],
  [],
  OptionsSlice
> = () => ({
  terms: false,
  privatePolicy: false,
});
